// import axios, { AxiosPromise } from 'axios';

import axios, { AxiosResponse } from 'axios';

import config from '../config'

import { DeliveryPriceSettingsResponse, DeliveryPriceSettings } from '@/types/price-settings'
import { ProductWorkService, UpdateProductStatusRequest } from '@/types/product'
import { DictItem } from '@/types/product/DictItem';
import { Attribute, AttributeRequestParams } from '@/types/product/Attribute';
import { Property } from '@/types/product/Property';
import { CategoryType } from '@/types/product/CategoryType';
import { UnitsModel } from '@/types/common';
import { Responsible } from '@/types/product/Responsible';

const instance = axios.create({
    baseURL: config.merchantWebApiUrl,
    timeout: 300000,
    withCredentials: true,
    headers: {Pragma: 'no-cache'}
});

export class MerchantApi {

    public static getDeliveryPriceSettings = (productId: number) => instance.post<DeliveryPriceSettingsResponse>('/ProductPriceSetting/GetDeliveryPriceSettings', { ProductId: productId });

    public static getPickupPriceSettings = (productId: number) => instance.post<DeliveryPriceSettingsResponse>('/ProductPriceSetting/GetWarehousePriceSettings', { ProductId: productId }); ///*

    public static updateDeliveryPriceSettings = (data: DeliveryPriceSettings[], productId: number) => instance.post('/ProductPriceSetting/UpdateDeliveryPriceSettings', { Items: data, ProductId: productId });

    public static updatePickupPriceSettings = (data: DeliveryPriceSettings[], productId: number) => instance.post('/ProductPriceSetting/UpdateWarehousePriceSettings', { Items: data, ProductId: productId });

    public static saveProduct = (model: ProductWorkService) => instance.post<AxiosResponse<ProductWorkService>>(`/Product/Save`, model);

    public static copyProduct = (id: number) => instance.post<number>(`/Product/Copy`, { ProductId: id });

    public static updateProductStatus = (statusRequest: UpdateProductStatusRequest) => instance.post(`/Product/UpdateStatus`, statusRequest);

    public static getProduct = (id: number) => instance.get<ProductWorkService>(`/Product/GetEditModel`, { params: { id: id }});

    public static getProductCategories = (id = 0) => instance.get<DictItem[]>(`ProductCategory/GetProductCategories`, { params: { parentId: id} });

    public static getAttributes = (params: AttributeRequestParams) => instance.post<Attribute[]>(`ProductCategory/GetAttributes`, params);

    public static getBasicProperties = (params: CategoryType) => instance.get<Property[]>(`Product/GetBasicProperties`, { params: { categoryType: params } });

    public static getUnitByCode = (code: string) => instance.get<UnitsModel>(`Unit/GetByCode`, { params: { code: code } });

    public static getOkpd2ByCategory = (categoryId: number) => instance.get<DictItem[]>(`ProductCategory/GetOkpd2ByCategory?categoryId=${categoryId}`);    

    public static getResponsibleUser = () => instance.get<Responsible>(`Product/GetResponsibleUser`);
}